/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AllocationRuleTemplateDto } from '../model';
// @ts-ignore
import type { CreateAllocationRuleTemplateDto } from '../model';
// @ts-ignore
import type { UpdateAllocationRuleTemplateDto } from '../model';
/**
 * AllocationRulesTemplateApi - axios parameter creator
 */
export const AllocationRulesTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateAllocationRuleTemplateDto} [createAllocationRuleTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationRulesTemplateCreate: async (createAllocationRuleTemplateDto?: CreateAllocationRuleTemplateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/AllocationRulesTemplate/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAllocationRuleTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationRulesTemplateDelete: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/AllocationRulesTemplate/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationRulesTemplateGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/AllocationRulesTemplate/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationRulesTemplateGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/AllocationRulesTemplate/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationRulesTemplateIsNameUnique: async (name?: string, id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/AllocationRulesTemplate/IsNameUnique`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateAllocationRuleTemplateDto} [updateAllocationRuleTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationRulesTemplateUpdate: async (updateAllocationRuleTemplateDto?: UpdateAllocationRuleTemplateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/AllocationRulesTemplate/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAllocationRuleTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllocationRulesTemplateApi - functional programming interface
 */
export const AllocationRulesTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllocationRulesTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateAllocationRuleTemplateDto} [createAllocationRuleTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationRulesTemplateCreate(createAllocationRuleTemplateDto?: CreateAllocationRuleTemplateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationRuleTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationRulesTemplateCreate(createAllocationRuleTemplateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationRulesTemplateApi.allocationRulesTemplateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationRulesTemplateDelete(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationRulesTemplateDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationRulesTemplateApi.allocationRulesTemplateDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationRulesTemplateGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationRuleTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationRulesTemplateGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationRulesTemplateApi.allocationRulesTemplateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationRulesTemplateGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AllocationRuleTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationRulesTemplateGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationRulesTemplateApi.allocationRulesTemplateGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationRulesTemplateIsNameUnique(name?: string, id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationRulesTemplateIsNameUnique(name, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationRulesTemplateApi.allocationRulesTemplateIsNameUnique']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateAllocationRuleTemplateDto} [updateAllocationRuleTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocationRulesTemplateUpdate(updateAllocationRuleTemplateDto?: UpdateAllocationRuleTemplateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationRuleTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocationRulesTemplateUpdate(updateAllocationRuleTemplateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationRulesTemplateApi.allocationRulesTemplateUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AllocationRulesTemplateApi - factory interface
 */
export const AllocationRulesTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllocationRulesTemplateApiFp(configuration)
    return {
        /**
         * 
         * @param {AllocationRulesTemplateApiAllocationRulesTemplateCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationRulesTemplateCreate(requestParameters: AllocationRulesTemplateApiAllocationRulesTemplateCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AllocationRuleTemplateDto> {
            return localVarFp.allocationRulesTemplateCreate(requestParameters.createAllocationRuleTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AllocationRulesTemplateApiAllocationRulesTemplateDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationRulesTemplateDelete(requestParameters: AllocationRulesTemplateApiAllocationRulesTemplateDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.allocationRulesTemplateDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AllocationRulesTemplateApiAllocationRulesTemplateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationRulesTemplateGet(requestParameters: AllocationRulesTemplateApiAllocationRulesTemplateGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AllocationRuleTemplateDto> {
            return localVarFp.allocationRulesTemplateGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationRulesTemplateGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<AllocationRuleTemplateDto>> {
            return localVarFp.allocationRulesTemplateGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AllocationRulesTemplateApiAllocationRulesTemplateIsNameUniqueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationRulesTemplateIsNameUnique(requestParameters: AllocationRulesTemplateApiAllocationRulesTemplateIsNameUniqueRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.allocationRulesTemplateIsNameUnique(requestParameters.name, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AllocationRulesTemplateApiAllocationRulesTemplateUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocationRulesTemplateUpdate(requestParameters: AllocationRulesTemplateApiAllocationRulesTemplateUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AllocationRuleTemplateDto> {
            return localVarFp.allocationRulesTemplateUpdate(requestParameters.updateAllocationRuleTemplateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for allocationRulesTemplateCreate operation in AllocationRulesTemplateApi.
 */
export interface AllocationRulesTemplateApiAllocationRulesTemplateCreateRequest {
    readonly createAllocationRuleTemplateDto?: CreateAllocationRuleTemplateDto
}

/**
 * Request parameters for allocationRulesTemplateDelete operation in AllocationRulesTemplateApi.
 */
export interface AllocationRulesTemplateApiAllocationRulesTemplateDeleteRequest {
    readonly id?: string
}

/**
 * Request parameters for allocationRulesTemplateGet operation in AllocationRulesTemplateApi.
 */
export interface AllocationRulesTemplateApiAllocationRulesTemplateGetRequest {
    readonly id?: string
}

/**
 * Request parameters for allocationRulesTemplateIsNameUnique operation in AllocationRulesTemplateApi.
 */
export interface AllocationRulesTemplateApiAllocationRulesTemplateIsNameUniqueRequest {
    readonly name?: string

    readonly id?: string
}

/**
 * Request parameters for allocationRulesTemplateUpdate operation in AllocationRulesTemplateApi.
 */
export interface AllocationRulesTemplateApiAllocationRulesTemplateUpdateRequest {
    readonly updateAllocationRuleTemplateDto?: UpdateAllocationRuleTemplateDto
}

/**
 * AllocationRulesTemplateApi - object-oriented interface
 */
export class AllocationRulesTemplateApi extends BaseAPI {
    /**
     * 
     * @param {AllocationRulesTemplateApiAllocationRulesTemplateCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationRulesTemplateCreate(requestParameters: AllocationRulesTemplateApiAllocationRulesTemplateCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return AllocationRulesTemplateApiFp(this.configuration).allocationRulesTemplateCreate(requestParameters.createAllocationRuleTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AllocationRulesTemplateApiAllocationRulesTemplateDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationRulesTemplateDelete(requestParameters: AllocationRulesTemplateApiAllocationRulesTemplateDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return AllocationRulesTemplateApiFp(this.configuration).allocationRulesTemplateDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AllocationRulesTemplateApiAllocationRulesTemplateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationRulesTemplateGet(requestParameters: AllocationRulesTemplateApiAllocationRulesTemplateGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AllocationRulesTemplateApiFp(this.configuration).allocationRulesTemplateGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationRulesTemplateGetAll(options?: RawAxiosRequestConfig) {
        return AllocationRulesTemplateApiFp(this.configuration).allocationRulesTemplateGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AllocationRulesTemplateApiAllocationRulesTemplateIsNameUniqueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationRulesTemplateIsNameUnique(requestParameters: AllocationRulesTemplateApiAllocationRulesTemplateIsNameUniqueRequest = {}, options?: RawAxiosRequestConfig) {
        return AllocationRulesTemplateApiFp(this.configuration).allocationRulesTemplateIsNameUnique(requestParameters.name, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AllocationRulesTemplateApiAllocationRulesTemplateUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allocationRulesTemplateUpdate(requestParameters: AllocationRulesTemplateApiAllocationRulesTemplateUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return AllocationRulesTemplateApiFp(this.configuration).allocationRulesTemplateUpdate(requestParameters.updateAllocationRuleTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }
}

